import { render, staticRenderFns } from "./TablePatentsOrderAdmin.vue?vue&type=template&id=1027d37e"
import script from "./TablePatentsOrderAdmin.vue?vue&type=script&lang=js"
export * from "./TablePatentsOrderAdmin.vue?vue&type=script&lang=js"
import style0 from "./TablePatentsOrderAdmin.vue?vue&type=style&index=0&id=1027d37e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports